module.exports = __webpack_public_path__ + "static/media/login.a165244f.jpg";